import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, Trash2, Phone } from "lucide-react";
import { toast } from "sonner";

export default function AdminInbox() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => api.get("/contact").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setActive(m);
    if (!m.read) {
      await api.patch(`/contact/${m.id}`, { read: true });
      load();
    }
  };

  const remove = async (m) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/contact/${m.id}`);
    if (active?.id === m.id) setActive(null);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="grid grid-cols-12 min-h-[calc(100vh-56px)] lg:min-h-screen" data-testid="admin-inbox">
      <div className="col-span-12 lg:col-span-5 border-r border-neutral-200 bg-white">
        <div className="p-5 sm:p-8 border-b border-neutral-200">
          <p className="label-eyebrow mb-3">Messages</p>
          <h1 className="font-serif-display text-3xl sm:text-4xl text-[#1a1a1a]">Inbox</h1>
          <p className="text-xs text-neutral-500 mt-2">{items.length} total · {items.filter(i => !i.read).length} unread</p>
        </div>
        <ul className="divide-y divide-neutral-100">
          {items.length === 0 && <li className="p-8 text-sm text-neutral-500 italic" data-testid="no-messages">No messages yet.</li>}
          {items.map((m) => (
            <li key={m.id}>
              <button onClick={() => open(m)} className={`w-full text-left p-5 hover:bg-[#F7F0F1] transition-colors ${active?.id === m.id ? "bg-[#F7F0F1]" : ""} ${!m.read ? "border-l-2 border-[#6B1F2A]" : "border-l-2 border-transparent"}`} data-testid={`inbox-item-${m.id}`}>
                <div className="flex justify-between items-baseline gap-3">
                  <p className={`text-sm ${!m.read ? "font-semibold text-[#1a1a1a]" : "text-neutral-700"}`}>{m.name}</p>
                  <p className="text-xs text-neutral-400 whitespace-nowrap">{new Date(m.created_at).toLocaleDateString()}</p>
                </div>
                <p className="text-xs text-neutral-500 mt-1 truncate">{m.subject || m.message}</p>
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-span-12 lg:col-span-7 p-5 sm:p-8 lg:p-10">
        {!active ? (
          <div className="h-full flex items-center justify-center text-neutral-400 text-sm">Select a message to view</div>
        ) : (
          <div data-testid="inbox-detail">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-serif-display text-3xl text-[#1a1a1a]">{active.subject || "(No subject)"}</h2>
              <button onClick={() => remove(active)} className="text-sm text-neutral-500 hover:text-red-600 inline-flex items-center gap-1" data-testid="delete-message-btn"><Trash2 size={14} /> Delete</button>
            </div>
            <div className="flex flex-wrap gap-5 items-center mb-8 pb-6 border-b border-neutral-200">
              <p className="font-medium text-[#1a1a1a]">{active.name}</p>
              <a href={`mailto:${active.email}`} className="text-sm text-[#6B1F2A] inline-flex items-center gap-1 hover:underline"><Mail size={12} /> {active.email}</a>
              {active.phone && <a href={`tel:${active.phone}`} className="text-sm text-[#6B1F2A] inline-flex items-center gap-1 hover:underline"><Phone size={12} /> {active.phone}</a>}
              <p className="text-xs text-neutral-400 ml-auto">{new Date(active.created_at).toLocaleString()}</p>
            </div>
            <div className="prose-body whitespace-pre-wrap">{active.message}</div>
            <div className="mt-10">
              <a href={`mailto:${active.email}?subject=Re: ${encodeURIComponent(active.subject || "Your message to Spirit & Associates")}`} className="btn-primary-burgundy">Reply via email</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
